require('./scss/button.scss');

export default {
    name: 'gm-button',
    template: `
        <div class="gm-button" :class="{
                'fixed-bottom': position == 'bottom',
                'fixed-button': position !== null,
            }">
            <component
                :is="componentType"
                :type="componentType == 'button' ? 'button' : ''"
                :href="href"
                :style="radius"
                :class="{
                    'btn-busy': busy,
                    'btn-primary btn-block btn-next': type == 'next',
                    'btn-primary btn-block btn-save': type == 'save',
                    'btn-block btn-outline-primary': type == 'outline',
                    'btn-link': type == 'link',
                    'btn-primary btn-block btn-next btn-icon-prefix': type == 'prefix',
                }"
                @click="handleClick"
                :disabled="disabled"
                class="btn btn-solid"
            >
                <slot v-if="!busy || type == 'link'"></slot>
                <div v-if="busy">
                    <div class="spinner-container"><span class="spinner"></span></div>
                    <span>&nbsp;</span>
                </div>
            </component>
        </div>
    `,
    
    props: {
        type: { type: String },
        href: { type: String },
        busy: { type: Boolean, default: false },
        position: { type: String, default: null },
        disabled: { type: Boolean, default: false },
        bottomRightRadius: { type: String, default: null },
        bottomLeftRadius: { type: String, default: null },
        TopRightRadius: { type: String, default: null },
        TopLeftRadius: { type: String, default: null },
    },

    computed: {
        radius() {
            return `
                border-bottom-right-radius: ${this.bottomRightRadius}px;
                border-bottom-left-radius: ${this.bottomLeftRadius}px;
                border-top-right-radius: ${this.TopRightRadius}px;
                border-top-left-radius: ${this.TopLeftRadius}px;
            `;
        },
        componentType() {
            if(this.href) {
                return 'a';
            }

            return 'button';
        }
    },

    methods: {
        handleClick() {
            if(!this.busy) {
                this.$emit('click');
            }
        },
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/Components/shared/Button.js